/** Shown when an uploaded brand image (background, logo, overlay) cannot be decoded. */
export const invalidImageFileMessage = (): string =>
  $localize`:@@roomBrand.invalidImageFile:Invalid image file. Please use a PNG or JPEG image.`;
